import { type RouteConfig } from 'vue-router'

export const YurplanTicketsRouter: RouteConfig[] = [
  {
    path: '/yurplan-tickets',
    component: async () => import('./YurplanTickets.vue'),
  },
]
